import { useState } from "react";
import styles from "./ApplianceSelector.module.scss";

import { DeleteIcon } from "../../../../../assets/icons";
import { Appliance } from "../../../../../model/appliance";
import Button from "../../../../../common/components/xepp/button/Button";
import { SelectedAppliance } from "../../request.type";

// Modal component for editing appliance details
interface ApplianceEditModalProps {
	appliance: Appliance;
	initialData: SelectedAppliance;
	onSave: (data: SelectedAppliance) => void;
	onRemove?: () => void;
	onCancel: () => void;
}

export const ApplianceEditModal: React.FC<ApplianceEditModalProps> = ({ appliance, initialData, onSave, onRemove, onCancel }) => {
	const [quantity, setQuantity] = useState(initialData.quantity);
	const [usage, setUsage] = useState(initialData.usage);

	const handleSave = () => {
		onSave({
			id: appliance.id,
			quantity,
			usage,
		});
	};

	const incrementValue = (setter: React.Dispatch<React.SetStateAction<number>>) => {
		setter(prev => prev + 1);
	};

	const decrementValue = (setter: React.Dispatch<React.SetStateAction<number>>) => {
		setter(prev => Math.max(1, prev - 1));
	};

	return (
		<div className={styles.modal}>
			{/* Modal Header */}
			<div className={styles.modalHeader}>
				<button className={styles.backButton} onClick={onCancel}>
					<span className={styles.backIcon}>←</span>
				</button>
				<div className={styles.headerContent}>
					<h2 className={styles.modalTitle}>List of Appliances</h2>
					<p className={styles.modalSubtitle}>Search and select an appliance to continue.</p>
				</div>
			</div>

			{/* Appliance Info */}
			<div className={styles.applianceHeader}>
				<div className={styles.applianceInfo}>
					<img className={styles.applianceIcon} src={appliance.iconUrl} alt={appliance.name}></img>
					<span className={styles.applianceName}>{appliance.name}</span>
				</div>
				{onRemove && <Button text="Remove" variant="outline" onClick={onRemove} rightIcon={<span className={styles.removeIcon}><DeleteIcon/></span>} />}
			</div>

			{/* Form Fields */}
			<div className={styles.formFields}>
				{/* Quantity */}
				<div className={styles.formField}>
					<div className={styles.fieldInfo}>
						<label className={styles.fieldLabel}>Quantity</label>
						<p className={styles.fieldDescription}>The number of {appliance.name.toLowerCase()}s to be used</p>
					</div>
					<div className={styles.fieldControls}>
            <div className={styles.fieldValue}>
						<input className={styles.fieldInput} value={quantity}></input>
            </div>
						<div className={styles.controlButtons}>
							<button className={styles.controlButton} onClick={() => decrementValue(setQuantity)}>
								−
							</button>
							<button className={styles.controlButton} onClick={() => incrementValue(setQuantity)}>
								+
							</button>
						</div>
					</div>
				</div>

				{/* Daily Usage */}
				<div className={styles.formField}>
					<div className={styles.fieldInfo}>
						<label className={styles.fieldLabel}>Daily usage (Hrs)</label>
						<p className={styles.fieldDescription}>How long will this device be in use</p>
					</div>
					<div className={styles.fieldControls}>
            <div className={styles.fieldValue}>
						<input className={styles.fieldInput} value={usage}></input>
						<span className={styles.fieldUnit}>Hrs</span>
            </div>
						<div className={styles.controlButtons}>
							<button className={styles.controlButton} onClick={() => decrementValue(setUsage)}>
								−
							</button>
							<button className={styles.controlButton} onClick={() => incrementValue(setUsage)}>
								+
							</button>
						</div>
					</div>
				</div>
				<div className={styles.modalActions}>
					<Button text="Save" variant="primary" onClick={handleSave} />
				</div>
			</div>
			{/* Save Button */}
		</div>
	);
};